import {
    adapts,
    AmazonS3LinkedServiceAdapter
} from 'app/model/adapters/linkedservices/amazon-s3-linkedservice.adapter';
import { AdapterRegistry, IModel, Metamodel, SapDatasphereForAmazons3LinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForAmazons3LinkedService),
    asynchronous: true,
    adapts
})
export class SapDatasphereForAmazonS3LinkedServiceAdapter extends AmazonS3LinkedServiceAdapter {
    protected modelConstructor(): new () => SapDatasphereForAmazons3LinkedService {
        return SapDatasphereForAmazons3LinkedService;
    }

    protected model(): IModel {
        return SapDatasphereForAmazons3LinkedService.MODEL;
    }
}
